import * as React from 'react';
import { observer } from 'mobx-react';

import { Checkbox } from 'office-ui-fabric-react';
import { IDisabledProps } from '@app/Models/IDisabledProps';
import { PersonInfoModel } from '@app/Models';
import { securityService } from '@app/Services/SecurityService';
import { Permissions } from '@app/AppConstants';
import { AzureAuth } from '@app/Components/AzureAuth';

type ChangeCheckboxCallback = (field: keyof PersonInfoModel, value: boolean) => void;

type PersonSettingsBlockProps =  IDisabledProps & {
    personInfo: PersonInfoModel;
    onChangeCheckboxHandler: ChangeCheckboxCallback;
};

@observer
export class PersonSettingsBlock extends React.Component<PersonSettingsBlockProps, {}> {
    render() {
		const {personInfo} = this.props;
		if (!personInfo) return;
        const { hasPermission, permissionCss } = securityService;
        return (
			<fieldset className="person-info-intranet">
				<legend>Settings</legend>
                {hasPermission(Permissions.ViewPersonEnableNbu) &&
                    <div className={'row' + permissionCss(Permissions.ViewPersonEnableNbu, Permissions.EditPersonEnableNbu)}>
                        <div className="col">
                            <Checkbox
                                label="Enable NBU"
                                checked={personInfo.enableNbu}
                                onChange={this._onEnableNbuChange}
                                disabled={!hasPermission(Permissions.EditPersonEnableNbu, !AzureAuth.isReadOnly)}
                            />
                        </div>
                    </div>
                }
            </fieldset>
        );
    }

	private _onEnableNbuChange = (ev?: React.FormEvent<HTMLElement | HTMLInputElement>, checked?: boolean) => {
        if (!securityService.hasPermission(Permissions.EditPersonEnableNbu, !AzureAuth.isReadOnly)) return;
        this.props.onChangeCheckboxHandler('enableNbu', !!checked);
	};
}